<template>
    <div v-loading="loading">
        <el-upload class="upload-demo" multiple ref="upload" :action="upAdress" :on-preview="handlePreview"
                   :on-remove="handleRemove" :file-list="fileList" accept=".pdf, .PDF" :on-change="changeFile" :on-success="success"
                   :on-error="error" :headers="headers" :auto-upload="false" :before-upload="beforeUpload_u">
            <template #trigger>
                <el-button size="small" type="primary" v-if="selectfile">选取文件</el-button>
            </template>
            <!--用户选择完文件自动上传，暂时注释-->
            <!--<el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload" v-if="uploadSource">
                上传到服务器
            </el-button>-->
            <el-button style="margin-left: 10px" size="small" type="success" @click="alldownLoadFiles">
                下载所有文件
            </el-button>
            <el-button style="margin-left: 10px" size="small" type="success" @click="returnResources">
                返回预算绩效情况说明
            </el-button>
            <el-button style="margin-left: 10px" size="small" type="success" @click="deleteAllfiles">
                删除全部绩效文件
            </el-button>
        </el-upload>
        <!--获取已经上传的数据-->
        <el-table :data="attachmentsList" style="width: 100%;margin-top:10px;" @selection-change="handleSelectionChange" border>
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column label="文件名" width="500">
                <template #default="scope">
                    <span>{{ scope.row.fileName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="类型" align="center">
                <template #default="scope">
                    <span v-if="scope.row.claims.tag == 'zphzb'"> 自评情况汇总表 </span>
                    <span v-if="scope.row.claims.tag == 'jxzpb'"> 绩效自评表 </span>
                    <span v-if="scope.row.claims.tag == 'czpjjg'">财政绩效评价结果</span>
                    <span v-if="scope.row.claims.tag == 'bmpjjg'">{{$store.state.openYear=='2021'&& $store.state.openType=='js' ?  ($store.state.divData.type == 0 ? '重点绩效评价项目' : '部门评价项目绩效评价结果') :'部门绩效评价结果'}}</span>
                    <span v-if="scope.row.claims.tag == 'jxpjbg'"> {{$store.state.openYear=='2021'&& $store.state.openType=='js' && $store.state.divData.type == 0 ? '重点' : ''}}绩效评价报告 </span>
                    <span v-if="scope.row.claims.tag == 'jxmbb'">
                        {{($store.state.openYear=='2022' || $store.state.openYear=='2021') && $store.state.openType=='ys' ? '部门预算重点项目的绩效目标表' : '绩效目标表'}}
                    </span>
                    <span v-if="scope.row.claims.tag == 'bmzxzj'">
                        {{$store.state.openYear=='2021'&& $store.state.openType=='ys' ? '项目资金的绩效目标表' : '专项资金绩效目标表'}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <el-button size="mini" @click="handleDown(scope.$index, scope.row)">下载</el-button>
                    <el-button size="mini" @click="PreView(scope.$index, scope.row)">预览</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <p v-if="allShow"><a href="#" @click="getDivListmore">更多...</a></p>
    </div>
</template>
<script>
    import url from "@/api/config.js";
    import { getPerformanceList } from "@/api/index.js";
    import {
        addAttachment,
        downloadAttachment,
        deleteAttachment,
        downloadAttachments,
    } from "@/api/div.js";

    export default {
        name: "uploadPerform",
        data() {
            return {
                fileList: [],
                upAdress: "",
                allformData: [],
                selectfile: false,
                uploadSource: false,
                tags: "zphzb,jxzpb,czpjjg,bmpjjg,jxpjbg,jxmbb,bmzxzj",
                headers: {
                    session: window.$cookies.get("session"),
                    zone: window.$cookies.get("zone"),
                },
                //已经上传的绩效文件
                attachmentsList: [],
                //选择的绩效文件
                multipleSelection: [],
                loading: false,
                pageNumber: 1, // 当前页码
                pagesize: 20, // 每页显示的行数,
                allShow: true,
                allLoading: false,
            };
        },
        created() {
            let tag = this.$route.query.tag;
            if (tag != "" && tag != undefined) {
                this.selectfile = true;
                this.uploadSource = true;
            } else {
                this.selectfile = false;
                this.uploadSource = false;
            }
            if (localStorage.getItem("ipUrl")) {
                let ipUrl = localStorage.getItem("ipUrl");
                this.upAdress = `${ipUrl}/div/addAttachment`;
            } else {
                this.upAdress = `${url.baseUrl.dev}div/addAttachment`;
            }
            this.getDivList();
        },
        watch: {
            $route(to, from) {
                let tag = this.$route.query.tag;
                if (tag != "" && tag != undefined) {
                    this.selectfile = true;
                    this.uploadSource = true;
                } else {
                    this.selectfile = false;
                    this.uploadSource = false;
                }
            },
        },
        methods: {
            //获取已经上传的信息
            async getDivList() {
                this.pageNumber = 1;
                let res = await getPerformanceList({
                    id: this.$route.query.divid,
                    tags: this.tags,
                    pageNumber: 1,
                    pageSize: 20,
                });
                if (res.status == 0) {
                    this.attachmentsList = res.files;
                    this.attachmentsList.reverse();
                }
                this.allShow = true;
            },

            //获取更多上传的信息
            async getDivListmore() {
                this.pageNumber++;
                let res = await getPerformanceList({
                    id: this.$route.query.divid,
                    tags: this.tags,
                    pageNumber: this.pageNumber,
                    pageSize: this.pagesize,
                });
                if (res.status == 0) {
                    if (res.files.length > 0) {
                        if (this.pageNumber == 1) {
                            this.attachmentsList = res.files;
                            this.allShow = true;
                        } else if (this.pageNumber > 1) {
                            if (res.files.length < this.pagesize) {
                                this.allShow = false
                            }
                            this.attachmentsList = this.attachmentsList.concat(res.files);
                            this.attachmentsList.reverse();
                        }
                    } else {
                        this.allShow = false
                    }
                }
            },
            //返回预算绩效情况说明
            returnResources() {
                this.$router.push({
                    name: "情况说明",
                    query: { divid: this.$route.query.divid },
                });
            },
            //打包下载所有绩效文件
            async alldownLoadFiles() {
                if (this.attachmentsList.length <= 0) {
                    this.$message("没有上传的绩效文件,请上传");
                    return;
                }
                this.loading = true;
                let res = await downloadAttachments({ id: this.$route.query.divid });
                if (res.type == 'application/json') {
                    this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                    });
                } else {
                    var blob = new Blob([res], { type: "application/zip" });
                    var url = URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.download = "绩效文件压缩包";
                    link.href = url;
                    link.click();
                }
                this.loading = false;
            },
            //下载绩效文件
            async handleDown(index, row) {
                this.loading = true;
                let res = await downloadAttachment({ fileid: row.id });
                if (res.type == 'application/json') {
                    this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                    });
                } else {
                    var blob = new Blob([res], { type: "application/pdf" });
                    var url = URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.download = row.fileName;
                    link.href = url;
                    link.click();
                }
                this.loading = false;
            },
            //删除绩效文件
            async handleDelete(index, row) {
                this.loading = true;
                this.$confirm("您确定删除这条数据吗？")
                    .then(async (suc) => {
                        let res = await deleteAttachment({
                            id: this.$route.query.divid,
                            fileid: row.id,
                        });
                        if (res.status == 0) {
                            this.$message.success("删除成功");
                            this.getDivList();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });

            },
            //删除全部绩效文件
            async deleteAllfiles() {
                this.loading = true;
                for (let index = 0; index < this.multipleSelection.length; index++) {
                    const element = this.multipleSelection[index];
                    await deleteAttachment({
                        id: this.$route.query.divid,
                        fileid: element.id,
                    });
                }
                this.$confirm("确定删除所有绩效文件吗？")
                    .then((suc) => {
                        if (res.status == 0) {
                            this.$message.success("删除成功");
                            this.getDivList();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });

            },
            /**循环上传 */
            async uploadNew() {
                this.loading = true;
                const that = this;

                for (let i = 0; i < this.allformData.length; i++) {
                    let res = await addAttachment(this.allformData[i]);
                    if (res.status === 0) {
                        this.$message.success("上传成功");
                    }
                    //this.loading = false;
                }
                this.allformData.splice(0, 1)
                this.getDivList();
                that.$refs.upload.clearFiles();
                this.loading = false;
            },
            /**上传到服务器 */
            submitUpload() {
                if (this.allformData.length == 0) {
                    this.$message.error("请选择文件");
                } else {
                    this.uploadNew();
                }
            },
            //预览单个绩效文件
            async PreView(index, row) {
                this.loading = true;
                let res = await downloadAttachment({ fileid: row.id });
                if (res.type == 'application/json') {
                    this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                    });
                } else {
                    var blob = new Blob([res], { type: "application/pdf" });
                    var url = URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.download = row.fileName;
                    window.open(url, "_blank");
                }
                this.loading = false;
            },
            /**移除事件 */
            handleRemove(file, fileList) {
                fileList.splice(0, 1);
                //console.log("移除事件", file, fileList);
                for (let i = 0; i < this.allformData.length; i++) {
                    if (file.name === this.allformData[i].get("file").name) {
                        this.allformData.splice(i, 1);
                    }
                }
            },
            /**点击已上传文件 */
            handlePreview(file) {
                //console.log(file, 33333);
            },
            /**文件状态改变 */
            changeFile(file, fileList) {
                var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
                const extension = testmsg === "pdf";
                var bool = false;
                if (extension) {
                    bool = true;
                } else {
                    bool = false;
                }

                if (!extension) {
                    this.$alert(`上传文件只能是pdf格式!`);
                    this.handleRemove(file, fileList);
                    return bool;
                }
                let formData = new FormData();
                formData.append("file", file.raw);
                formData.append("id", this.$route.query.divid);
                formData.append("tag", this.$route.query.tag);
                this.allformData.push(formData);
                //无需用户点击，直接上传
                this.submitUpload()
            },
            // 上传成功
            success(response) {
                console.log("上传成功", response);
            },
            // 上传失败
            error(err) {
                console.log("上传失败", err);
            },

            mounted() {
                this.getDivList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }
        },
    };
</script>